import { CodeHighlight } from './code-highlight';
export default CodeHighlight;
